import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getReplenishment = (params) => {
    return axios.get(`${backendHost}/api/admin/replenishment/list`, {params});
};

export {
    getReplenishment
}